import React, { Component, useState } from "react";
import { useContext } from "react";
import { BsFillHeartFill } from "react-icons/bs";
import Slider from "react-slick";
import axios from "axios";
import { DemoLinks } from "./Home";

import {
  Accordion,
  Table,
  Carousel,
  Badge,
  Nav,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import CartContext from "./CartContext";
import { Features } from "./Products";
import { Showcase } from "./Showcase";
import { Pricing } from "./Pricing";
import { Services } from "./Home";
import {
  CommonModules,
  DemoButton,
  DigitalCatalogModule,
  KioskModule,
  MarketingModule,
  QuoteManagementModule,
  SuppliersModule,
} from "./CommonModules";

import {
  RetailPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  LeadsManagementModule,
  CouponsManagementModule,
  ECommerceB2CModule,
  ECommerceB2BModule,
} from "./CommonModules";

export class SolutionRetail extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <>
        <div class="container-fluid py-5">
          <div class="container">
            <div class="row gx-4 py-2">
              <div class="col-lg-12">
                <div>
                  <h6 class="text-primary text-uppercase">Solution</h6>
                  <h4 class="display-6  mb-0">
                    Modern Solution for Retail / WholeSale Business
                  </h4>
                  <h6>
                    We offer a modern retail software solution that supports
                    both B2C and B2B operations. It includes e-commerce, smart
                    POS, self-service kiosks, QR-based ordering, inventory and
                    supplier management, order workflow automation, integrated
                    delivery (including Shiprocket), RazorPay/PhonePe payments,
                    CRM with loyalty features, custom themes, and real-time
                    analytics dashboards — all in one powerful platform.
                  </h6>
                  <DemoButton></DemoButton>
                  <a href="images/Retail/retailoverview.png" target="_blank">
                    <img
                      class="w-100 rounded"
                      src="images/Retail/retailoverview.png"
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </div>
                <div className="col-lg-12 mb-lg-5 py-5">
                  <video
                    controls
                    height="400px"
                    autoPlay
                    muted
                    loop
                    width="100%"
                    // className="rounded shadow"
                    aria-label="POS software demo video"
                  >
                    <source
                      src={
                        this.context.GetEcSettingValueByName(
                          "StorageBlobImageUrl"
                        ) + "RetailERPVideo.mp4"
                      }
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div>
                  <h6 class="text-primary text-uppercase">Solution</h6>
                  <h4 class="display-6  mb-0">
                    Business Workflow - Our Solution
                  </h4>
                  <a href="images/Retail/retailworkflow.png" target="_blank">
                    <img
                      class="w-100 rounded"
                      src="images/Retail/retailworkflow.png"
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <DemoButton></DemoButton>
            <br />
            <div className="mb-4 CornersRoundedMedium bg-white border p-5 shadow-sm">
              <h4 className="display-6 fw-semibold mb-3">
                Why Choose Our Retail ERP?
              </h4>
              <FeatureSection
                title="Features & Benefits"
                items={[
                  "Purchase/Procurement Management",
                  "Suppliers Management",
                  "Inventory & Stocks Management",
                  "Point-Of-Sale (POS)",
                  "ECommerce B2C website",
                  "ECommerce B2B website",
                  "Lead Management",
                  "Quote Management",
                  "Orders Management",
                  "Packaging Management",
                  "Delivery Management",
                  "return and refund management",
                  "Customer Relationship Management (CRM)",
                  "Coupons Management",
                  "Accepts Cash, Card, UPI, QR Codes, COD, and Payment Gateway Integration",
                  "HR & Payroll Management",
                  "Accounting & Balance Sheet",
                  "AI-powered solutions",
                  "Real-time dashboard with sales, billing, and inventory reports",
                  "Advanced Reporting and Analytics",
                  "Multi-Store, Multi-Vendor, Multi-Currency",
                  "Free SSL and Custom domain",
                  "Use on any device: Phone, Tablet, or PC",
                ]}
              />
            </div>
            {/* ERP Modules Section */}
            <section className="container my-5">
              <h4 className="display-6 text-dark mb-4">
                Explore Integrated ERP Modules That Power Your Business
              </h4>
              <Row className="g-3">
                {[
                  PurchasesModule,
                  SuppliersModule,
                  InventoryModule,
                  RetailPosModule,
                  ECommerceB2CModule,
                  ECommerceB2BModule,
                  KioskModule,
                  OrdersManagementModule,
                  PackagingManagementModule,
                  DeliveryManagementModule,
                  MarketingModule,
                  DigitalCatalogModule,
                  CrmModule,
                  LeadsManagementModule,
                  QuoteManagementModule,
                  CouponsManagementModule,
                  HrmModule,
                  AccountingModule,
                  ReportsModule,
                ].map((Module, index) => (
                  <Col md={6} lg={6} key={index}>
                    <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                      <Module />
                    </div>
                  </Col>
                ))}
              </Row>
            </section>
            <DemoButton></DemoButton>
          </div>
        </div>
      </>
    );
  }
}

const FeatureSection = ({ title, items }) => (
  <div className="mb-4">
    <h5 className="fw-semibold">{title}</h5>

    <ul className="mb-0 ps-3">
      <Row>
        {items.map((item, idx) => (
          <Col xs={6} key={idx}>
            <li key={idx} className="mb-2">
              {item}
            </li>
            {/* <li key={idx}>{item}</li> */}
          </Col>
        ))}
      </Row>
    </ul>
  </div>
);
